<template>
  <HScaffold :title="useUser.phoneNumber===''?'绑定手机号':'已绑定手机号'">
    <EachLrContent v-if="useUser.phoneNumber===''" :showLastLine="false" style="margin: 10px;border-radius: 10px;"
                   :valueChangeCallback="valueChangeCallback" :isLogin="true" :isPasswdType="false"/>
    <HButton v-if="useUser.phoneNumber===''" :disabled="!isCanPress" title="确认绑定" :callback="clickBind"/>

    <div v-if="useUser.phoneNumber!==''" style="background-color: white;padding:10px;margin:10px;border-radius: 8px;display: flex;flex-direction: row;">
      <div :style="hcf.getTextStyle()">
        手机号码:
      </div>
      <div :style="hcf.getTextStyle({
      color:'#aaa'
      })">
        {{useUser.phoneNumber.slice(0,4)}}****{{useUser.phoneNumber.slice(useUser.phoneNumber.length-4,useUser.phoneNumber.length)}}
      </div>
    </div>

    <HServicePrase/>
  </HScaffold>
</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import EachLrContent from "@/components/pages/LoginRegister/EachLrContent.vue";
  import HButton from "@/components/utils/HButton.vue";
  import {useUserStore} from "@/stores/useUser.js";
  import {showToast} from "vant";
  import {hr} from "@/components/utils/HRouter.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import HServicePrase from "@/components/utils/HServicePrase.vue";

  const value1 = ref("");
  const value2 = ref("");
  const isCanPress = ref(false);
  let useUser = useUserStore();
  let useHttp = useHHttp();

  function valueChangeCallback(v1, v2, v3) {
    value1.value = v1;
    value2.value = v2;
    if (value1.value.length >= 11 && value2.value.length >= 4) {
      isCanPress.value = true;
    } else {
      isCanPress.value = false;
    }
  }

  function clickBind() {
    useHttp.request("/app/reg/mobile/bind",
        () => {
          useUser.phoneNumber = value1.value;
          showToast("手机绑定成功");
          hr.goBack();
        }, {
          params: {
            "AppId": useUser.appId,
            "UserId": useUser.userId,
            "Mobile": value1.value,
            "Captcha": value2.value,
            "AreaCode": useUser.areaCode
          }
        });
  }
</script>


<style scoped>

</style>
